import React from 'react';
import { IconSaxIcon } from '@/components/design-system/atoms/icon/iconsax-icon';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/design-system/atoms/button';

type DiscountHeaderProps = {
  hasDiscounts: boolean;
  onAddDiscount: () => void;
  onClose: () => void;
};

const DiscountHeader: React.FC<DiscountHeaderProps> = ({
  hasDiscounts,
  onAddDiscount,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {hasDiscounts ? (
          <h3 className="text-[16px] font-bold">
            {t('js.features.admin.contracts.discount_header.title') as string}
          </h3>
        ) : (
          <p className="font-bolc align-middle text-[16px] text-N900">
            {t('js.features.admin.contracts.discount_header.no_discounts') as string}
          </p>
        )}
      </div>
      <div className="flex gap-3">
        <Button
          variant="primary"
          size="medium"
          iconName="percentage-square"
          onClick={onAddDiscount}
          className="rounded-[8px] font-bold"
        >
          {t('js.features.admin.contracts.discount_header.add_button') as string}
        </Button>
        <Button
          variant="ghost"
          size="small"
          iconName="eye-slash"
          onClick={onClose}
          className="font-bold"
        >
          {t('js.features.admin.contracts.discount_header.hide_button') as string}
        </Button>
      </div>
    </div>
  );
};

export default DiscountHeader;
